import { actions } from "./actions";

export const ProgressPointState = {
  Complete: "Complete",
  InProgress: "InProgress",
  NotStarted: "NotStarted",
} as const;

export type ProgressPointState =
  typeof ProgressPointState[keyof typeof ProgressPointState];

export interface ProgressPoint {
  name: string;
  state: ProgressPointState;
}

export interface BaseInitialState<TData = unknown> {
  pageIndex: number;
  progressState: ProgressPoint[];
  data: TData;
}

export type ActionPayload<TData = unknown> =
  | { type: actions.RESET_TO_DEFAULT_DATA }
  | { type: actions.SET_PAGE_INDEX; payload: number }
  | { type: actions.INCREMENT_PAGE_INDEX }
  | { type: actions.DECREMENT_PAGE_INDEX }
  | { type: actions.SET_DATA; payload: TData };
